import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recherche-by-user',
  templateUrl: './recherche-by-user.component.html',
  styleUrls: ['./recherche-by-user.component.scss']
})
export class RechercheByUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
